<template>
  <div class="base-with-sidebar-layout">
    <main class="base-with-sidebar-layout__grid grid-container">
      <div class="base-with-sidebar-layout__header">
        <div class="base-with-sidebar-layout__logo">
          <BaseImage :src="isDark ? 'logo-primary.png' : '/text-logo-dark.svg'" />
        </div>
        <div>
          <BaseDropdownWrapper width="fill" placement="bottom-end" with-rounded>
            <template #control>
              <BaseButtonIcon
                icon-name="vuesax:more"
                form="circle"
                color="#3333331A"
                size="md-alt"
                data-testid="action-bar-btn"
              />
            </template>
            <template #dropdown="{ handleClose }">
              <BaseButton
                variant="light"
                data-testid="auth-logout-btn"
                @click="handleChangeTheme(handleClose)"
              >
                {{ isDark ? 'Светлая' : 'Тёмная' }} тема
              </BaseButton>
              <BaseButton
                variant="light"
                data-testid="auth-logout-btn"
                @click="handleLogout"
              >
                Выйти
              </BaseButton>
            </template>
          </BaseDropdownWrapper>
        </div>
      </div>
      <div v-if="$slots.sidebar" class="base-with-sidebar-layout__sidebar">
        <slot name="sidebar" />
      </div>
      <div class="base-with-sidebar-layout__content">
        <slot />
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import { useAuth } from '~/entities/auth'
import { useNotificationStore, useTheme } from '~/shared/lib'
import {
  BaseButton,
  BaseButtonIcon,
  BaseDropdownWrapper,
  BaseImage,
} from '~/shared/ui'

const { logout } = useAuth()
const { notify } = useNotificationStore()
const { toggleTheme, isDark } = useTheme()

function handleChangeTheme(close: () => void) {
  toggleTheme()
  close()
}

function handleLogout() {
  logout()
  notify({
    message: 'Вы вышли из аккаунта',
    type: 'success',
  })
}
</script>

<style lang="scss" scoped>
.base-with-sidebar-layout {
  min-height: 100dvh;
  height: 100%;
  background-color: var(--color-surface-placeholder);

  &__grid {
    @include responsive-grid(
      (
        "xs": 4,
      )
    );

    padding-bottom: rem(28px);
    grid-row-gap: 0 !important;
    grid-template-rows: 96px 1fr;

    @include bp-media('xs', 'sm') {
      grid-template-rows: 80px 1fr;
      gap: var(--grid-gap-table);
      padding-left: rem(18px);
      padding-right: rem(18px);
    }

    @include bp-media('xs') {
      grid-template-rows: 80px auto 1fr;
      gap: var(--grid-gap-mobile);
      padding-left: rem(16px);
      padding-right: rem(16px);
    }
  }

  &__header {
    grid-row: 1 / 2;
    grid-column: 1 / -1;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__logo {
    width: 121px;
    height: 40px;
  }

  &__sidebar {
    grid-row: 2 / 3;
    grid-column: span 3;

    @include bp-media('xs', 'sm') {
      grid-column: span 2;
    }

    @include bp-media('xs') {
      grid-column: 1 / -1;
      margin-bottom: rem(16px);
    }

    :deep(> *) {
      position: sticky;
      top: var(--grid-gap);

      @include bp-media('xs', 'sm') {
        top: var(--grid-gap-table);
      }

      @include bp-media('xs') {
        position: static;
        top: 0;
      }
    }
  }

  &__content {
    @include grid(9, var(--grid-gap));

    grid-auto-flow: row dense;
    grid-row: 2 / 3;
    grid-column: span 9;
    align-self: start;

    @include bp-media('xs', 'sm') {
      @include grid(10, var(--grid-gap-table));

      grid-column: span 10;
    }

    @include bp-media('xs') {
      @include grid(4, var(--grid-gap-mobile));

      grid-row: 3 / 4;
      grid-column: 1 / -1;
    }
  }
}
</style>
